<template>
    <v-card class="p-3">
        <h5>Dernière synchronisation Hawwwai</h5>
        <div>
            <small v-if="lastSyncDate === null">
                Aucune synchronisation pour le moment
            </small>
            <small v-else>
                Le {{ formatDate(lastSyncDate) }}
            </small>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "LastSyncBloc",
    props: ['lastSyncDate'],
}
</script>